import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLTableHeaders = () => {
  return (
    <div className="html-container">
      <h1>HTML – Table Headers</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          Table headers provide meaningful labels for table columns or rows, improving readability and accessibility. They are created using the <code>&lt;th&gt;</code> element.
        </p>
      </section>

      {/* 2. Column Headers */}
      <section id="column-headers">
        <h2>2. Column Headers</h2>
        <p>Column headers appear at the top of a table and describe the content of each column:</p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th>Name</th>
    <th>Age</th>
    <th>City</th>
  </tr>
  <tr>
    <td>John</td>
    <td>25</td>
    <td>New York</td>
  </tr>
  <tr>
    <td>Mary</td>
    <td>30</td>
    <td>London</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 3. Row Headers */}
      <section id="row-headers">
        <h2>3. Row Headers</h2>
        <p>Row headers appear at the start of each row:</p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th></th>
    <th>Math</th>
    <th>Science</th>
  </tr>
  <tr>
    <th>John</th>
    <td>90</td>
    <td>85</td>
  </tr>
  <tr>
    <th>Mary</th>
    <td>95</td>
    <td>92</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 4. Scope Attribute */}
      <section id="scope">
        <h2>4. Scope Attribute</h2>
        <p>
          Use the <code>scope</code> attribute to indicate whether a header is for a row or a column. This improves accessibility for screen readers.
        </p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th scope="col">Name</th>
    <th scope="col">Age</th>
    <th scope="col">City</th>
  </tr>
  <tr>
    <th scope="row">John</th>
    <td>25</td>
    <td>New York</td>
  </tr>
  <tr>
    <th scope="row">Mary</th>
    <td>30</td>
    <td>London</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 5. Styling Table Headers */}
      <section id="styling">
        <h2>5. Styling Table Headers</h2>
        <p>You can use CSS to style headers differently from regular cells:</p>
        <pre>
          <code>{`<style>
th {
  background-color: #007bff;
  color: white;
  padding: 10px;
  text-align: left;
}
td {
  padding: 10px;
}
</style>`}</code>
        </pre>
      </section>

      {/* 6. Summary */}
      <section id="summary">
        <h2>6. Summary</h2>
        <ul>
          <li>Use <code>&lt;th&gt;</code> for table headers, not <code>&lt;td&gt;</code>.</li>
          <li>Column headers describe the content of columns; row headers describe rows.</li>
          <li>Use <code>scope="col"</code> or <code>scope="row"</code> for accessibility.</li>
          <li>CSS can style headers differently for better readability.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLTableHeaders;
